/**
 * Author: leo Date: 03/12/2018
 */

export enum KeyboardEvents {
	KEY_DOWN = "keydown",
	KEY_PRESS = "keypress",
	KEY_UP = "keyup",
}
